import type { DataTableColumn, DataTableRenderCellParams } from '@/components/custom/erp';
import { DonViTinh, QuyDoiDonViTinhChiTiet, VatTu } from '@/types/schemas';
import { formatNumber } from '@/lib/formatUtils';

export const getDataTableColumns = (
  handleViewClick: (row: QuyDoiDonViTinhChiTiet) => void
): DataTableColumn<QuyDoiDonViTinhChiTiet>[] => [
  {
    field: 'ma_vt',
    headerName: 'Mã vật tư',
    width: 120,
    renderCell: (params: DataTableRenderCellParams<QuyDoiDonViTinhChiTiet>) => (
      <button onClick={() => handleViewClick(params.row)} className='hover:text-blue-500 hover:underline'>
        {params.row.ma_vt_data?.ma_vt || params.value}
      </button>
    )
  },
  {
    field: 'ten_vt',
    headerName: 'Tên vật tư',
    width: 200,
    renderCell: (params: DataTableRenderCellParams<QuyDoiDonViTinhChiTiet>) => params.row.ma_vt_data?.ten_vt
  },
  {
    field: 'dvt',
    headerName: 'Đơn vị tính',
    width: 100,
    renderCell: (params: DataTableRenderCellParams<QuyDoiDonViTinhChiTiet>) =>
      params.row.dvt_data?.dvt || params.row.dvt
  },
  {
    field: 'he_so',
    headerName: 'Hệ số',
    width: 120,
    align: 'right',
    renderCell: (params: DataTableRenderCellParams<QuyDoiDonViTinhChiTiet>) => {
      const value = params.value;
      if (value === null || value === undefined) return '';
      return String(value);
    }
  },
  {
    field: 'dvt_goc',
    headerName: 'Đơn vị tính gốc',
    width: 150
  },
  {
    field: 'khoi_luong',
    headerName: 'Khối lượng',
    width: 120,
    align: 'right',
    renderCell: (params: DataTableRenderCellParams<QuyDoiDonViTinhChiTiet>) => {
      const value = params.row.khoi_luong ?? params.value;
      if (value == null || value === '') return '';
      return formatNumber(value as number | string);
    }
  }
];

export const vatTuSearchColumns: DataTableColumn<VatTu>[] = [
  { field: 'ma_vt', headerName: 'Mã vật tư', width: 120 },
  { field: 'ten_vt', headerName: 'Tên vật tư', width: 200 },
  { field: 'don_vi_tinh', headerName: 'Đvt', width: 100 },
  { field: 'nhom_1', headerName: 'Nhóm 1', width: 120 },
  { field: 'lo_yn', headerName: 'Theo dõi lô', width: 120 },
  { field: 'qc_yn', headerName: 'Quy cách', width: 150 },
  { field: 'hinh_anh', headerName: 'Hình ảnh', width: 120 }
];

export const donViTinhSearchColumns: DataTableColumn<DonViTinh>[] = [
  { field: 'dvt', headerName: 'Đvt', width: 100 },
  { field: 'ten_dvt', headerName: 'Tên đơn vị tính', width: 200 }
];
